import { render, staticRenderFns } from "./ListSectionWrapper.vue?vue&type=template&id=143b8625&"
import script from "./ListSectionWrapper.vue?vue&type=script&lang=js&"
export * from "./ListSectionWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('143b8625')) {
      api.createRecord('143b8625', component.options)
    } else {
      api.reload('143b8625', component.options)
    }
    module.hot.accept("./ListSectionWrapper.vue?vue&type=template&id=143b8625&", function () {
      api.rerender('143b8625', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/dynamicViews/ListSectionWrapper.vue"
export default component.exports